import { render, staticRenderFns } from "./non-real-name-card-management.vue?vue&type=template&id=048b8160&"
import script from "./non-real-name-card-management.vue?vue&type=script&lang=ts&"
export * from "./non-real-name-card-management.vue?vue&type=script&lang=ts&"
import style0 from "./non-real-name-card-management.vue?vue&type=style&index=0&id=048b8160&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports